<app-secondary-popup
  [title]="'Generate Link'"
  [isActionButtonsAvailable]="false"
  (popupClosed)="closePopup($event)"
>
  <div class="link-create-form">
    <!-- Form Mode -->
    <div>
      <!-- Link Name Input -->
      <div class="form-group">
        <label for="linkName" class="form-label">Link Name</label>
        <input
          id="linkName"
          type="text"
          class="form-input"
          [(ngModel)]="linkName"
          placeholder="Enter link name"
          required
        />
      </div>

      <!-- Visibility of submissions Input -->
      <div class="form-group">
        <div class="text_field">
          <label for="company_name">Visibility of submissions</label>
          <div class="right-actions">
            <a href="javascript:void(0);" class="has-tooltip">
              <div class="tooltip" role="tooltip">
                <div class="arrow-down"></div>
                <div class="name">
                  Controls whether submissions received through this link are
                  visible publicly or kept private.
                </div>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                <path
                  d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                />
              </svg>
            </a>
          </div>
        </div>
        <div class="radio-group">
          <label>
            <input
              type="radio"
              name="submissionVisibility"
              [value]="1"
              [(ngModel)]="submissionVisibility"
              required
            />
            Public
          </label>

          <label>
            <input
              type="radio"
              name="submissionVisibility"
              [value]="2"
              [(ngModel)]="submissionVisibility"
              required
            />
            Private
          </label>
        </div>
      </div>

      <!-- Key-Value Pairs Section -->
      <div class="form-group">
        <div class="form-label">Additional Parameters</div>
        <div class="key-value-section">
          @for (pair of keyValuePairs; track $index) {
            <div class="key-value-pair">
              <div class="input-group">
                <input
                  type="text"
                  class="form-input key-input"
                  [(ngModel)]="pair.key"
                  placeholder="Eg: Location"
                />
                <input
                  type="text"
                  class="form-input value-input"
                  [(ngModel)]="pair.value"
                  placeholder="Coffee shop"
                />
                <button
                  type="button"
                  class="btn btn-icon btn-delete"
                  [disabled]="keyValuePairs.length <= 1"
                  (click)="removeKeyValuePair($index)"
                  title="Remove parameter"
                >
                  <app-svg-icon
                    [iconName]="'delete.svg'"
                    [height]="'14px'"
                    [width]="'12px'"
                    [style.fill]="'#dc3545'"
                  ></app-svg-icon>
                </button>
              </div>
            </div>
          }

          <button
            type="button"
            class="btn btn-secondary btn-add"
            [disabled]="!canAddNewKeyValuePair"
            (click)="addKeyValuePair()"
            title="Add new parameter"
          >
            <app-svg-icon
              [iconName]="'add.svg'"
              [height]="'14px'"
              [width]="'14px'"
              [style.fill]="'#334ea5'"
            ></app-svg-icon>
            Add Parameter
          </button>
        </div>
      </div>

      <!-- Form actions -->
      <div class="form-actions">
        <button
          type="button"
          class="btn btn-primary"
          [class.loading]="isGenerating"
          [disabled]="!isGenerateButtonEnabled"
          (click)="generateLink()"
        >
          @if (isGenerating) {
            <span>Generating...</span>
          } @else {
            <span>Generate</span>
          }
        </button>
      </div>
    </div>
  </div>
</app-secondary-popup>
